<template>
  <div class="alphabet-pagination">
    <button
      v-for="letter in alphabet"
      :key="letter"
      :class="['pagination-button', { active: letter === selectedLetter }]"
      @click="selectLetter(letter)"
    >
      {{ letter }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'AlphabetPagination',
  data() {
    return {
      alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
      selectedLetter: 'A',
    };
  },
  methods: {
    selectLetter(letter) {
      this.selectedLetter = letter;
      this.$emit('letter-selected', letter);
    },
  },
};
</script>

<style scoped>
.alphabet-pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 20px 0;
}

.pagination-button {
  margin: 5px;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: white;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s ease;
}

.pagination-button:hover {
  background-color: #eee;
}

.pagination-button.active {
  background-color: #007bff;
  color: white;
  border-color: #007bff;
}
</style>
